import React from 'react';
import { MessageCircle, Package, Store, Wrench } from 'lucide-react';

const icons = [Wrench, Package, Store, MessageCircle];

/**
 * Timeline operacional — distinta da secção "Como funciona" (passos técnicos no backoffice).
 */
export function WsjPedidosSaaSFlowSection({ copy }) {
  const steps = copy.saasFlowSteps || [];

  return (
    <section id="wsj-pedidos-operacao" className="max-w-6xl mx-auto mb-20 sm:mb-28 scroll-mt-28">
      <div className="text-center mb-10 sm:mb-14">
        <h2 className="text-2xl sm:text-4xl font-black text-white tracking-tight">{copy.saasFlowTitle}</h2>
        <p className="text-white/50 mt-3 max-w-2xl mx-auto font-light leading-relaxed">{copy.saasFlowLead}</p>
      </div>

      <div className="relative max-w-2xl mx-auto pl-2 sm:pl-0">
        <div
          className="absolute left-[1.35rem] sm:left-[1.25rem] top-3 bottom-3 w-px bg-gradient-to-b from-amber-500/45 via-white/12 to-emerald-500/35 rounded-full pointer-events-none"
          aria-hidden
        />

        <ol className="relative space-y-6 sm:space-y-8">
          {steps.map((step, i) => {
            const Icon = icons[i] || Package;
            return (
              <li key={step.title} className="relative flex gap-4 sm:gap-6">
                <div className="relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-amber-500/35 bg-slate-950 shadow-[0_0_22px_-3px_rgba(212,165,116,0.4)]">
                  <span className="text-sm font-black text-amber-400 tabular-nums">{i + 1}</span>
                </div>
                <div className="min-w-0 flex-1 rounded-2xl border border-white/[0.08] bg-slate-950/50 backdrop-blur-md p-5 sm:p-6 transition-all duration-300 hover:border-amber-500/22 hover:bg-slate-950/70">
                  <div className="flex flex-col sm:flex-row sm:items-start gap-3">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-amber-500/10 border border-amber-500/20">
                      <Icon className="w-5 h-5 text-amber-400/95" aria-hidden />
                    </div>
                    <div className="min-w-0 flex-1">
                      <p className="text-[11px] font-bold uppercase tracking-wider text-amber-200/80 mb-1">
                        {copy.saasFlowStepLabel.replace('{n}', String(i + 1))}
                      </p>
                      <h3 className="text-base sm:text-lg font-bold text-white tracking-tight leading-snug">{step.title}</h3>
                      <p className="text-sm text-white/45 mt-2 leading-relaxed font-light break-words min-w-0">{step.desc}</p>
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
